run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','workPlanParametrization'];

//funcion donde se definen la run

export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,workPlanParametrization) {
                MenuConstant[0]['menu'].push(workPlanParametrization);
}


// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/workPlanParametrization.run.js